/**
 * @name user-round-group
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcgMjFhNSA1IDAgMDAtMTAgMCIgLz4KICA8cGF0aCBkPSJNMjIgMTAuNWEzLjUgMy41IDAgMDAtNS41MDctMi44NjgiIC8+CiAgPHBhdGggZD0iTTcuNTA3IDcuNjMyQTMuNSAzLjUgMCAwMDIgMTAuNSIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEzIiByPSIzIiAvPgogIDxjaXJjbGUgY3g9IjE4LjUiIGN5PSI0LjUiIHI9IjIuNSIgLz4KICA8Y2lyY2xlIGN4PSI1LjUiIGN5PSI0LjUiIHI9IjIuNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/user-round-group
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const UserRoundGroup: string = `
<svg
  class="lucide lucide-user-round-group"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M17 21a5 5 0 00-10 0" />
  <path d="M22 10.5a3.5 3.5 0 00-5.507-2.868" />
  <path d="M7.507 7.632A3.5 3.5 0 002 10.5" />
  <circle cx="12" cy="13" r="3" />
  <circle cx="18.5" cy="4.5" r="2.5" />
  <circle cx="5.5" cy="4.5" r="2.5" />
</svg>
`;

export default UserRoundGroup;
